export const drawerWidth = 240;
export const drawerCollapsedWidth = 70;
